<!-- 组件中转 -->
<template>
  <router-view :key="$route.name"></router-view>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'bus'
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/view-bus/index.vue"
}
</vue-filename-injector>
